import { Component, OnInit, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { MarketingBannerService } from 'src/app/core/services/marketing-banner.service';
import { MarketingBanner } from '../marketing-banner.interface';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DomSanitizer } from '@angular/platform-browser';
import { GooleAnalyticsEventsService } from 'src/app/core/services/goole-analytics-events.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { MatButton } from '@angular/material/button';


@Component({
    selector: 'app-marketing-banner-carousel',
    templateUrl: './marketing-banner-carousel.component.html',
    styleUrls: ['./marketing-banner-carousel.component.scss'],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    standalone: true,
    imports: [MatButton]
})
export class MarketingBannerCarouselComponent implements OnInit {
  @Input() services: any;
  subscription: Subscription;
  marketingBanners: MarketingBanner[] = [];
  config: any;
  bannerCount: number;
  bannerCountCurrent: number;
  xDown: number;
  yDown: number;
  currentIndex: number = 1;

  constructor(
    private marketingBannerService: MarketingBannerService,
    private googleAnalyticsEvents: GooleAnalyticsEventsService,
    private router: Router,
    private route: ActivatedRoute,
    private domSanitizer: DomSanitizer,
    breakpointObserver: BreakpointObserver) {
    breakpointObserver.observe([
      Breakpoints.Handset
    ]).subscribe(result => {
      if (result.matches) {
        this.config = {
          direction: 'horizontal',
          slidesPerView: 1,
          keyboard: false,
          mousewheel: false,
          scrollbar: false,
          pagination: true,
          initialSlide: 0,
          observer: true,
          simulateTouch: true,
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
          centeredSlides: false,
          spaceBetween: 5
        };
      } else {
        this.config = {
          direction: 'horizontal',
          centeredSlides: false,
          slidesPerView: 1,
          keyboard: true,
          mousewheel: false,
          scrollbar: false,
          pagination: true,
          initialSlide: 0,
          observer: true,
          simulateTouch: true,
          watchSlidesProgress: true,
          preventInteractionOnTransition: true,
          spaceBetween: 5
        };
      }
    });
  }

  ngOnInit(): void {
    this.marketingBannerService.getMarketingBanners().subscribe((data) => {
      this.marketingBanners = data['marketing_banners'];
      this.bannerCount = this.marketingBanners.length;
      this.sanitizeImages(this.marketingBanners);
    });
  }

  sanitizeImages(marketing_banners: MarketingBanner[]) {
    marketing_banners.forEach(banner => {
      banner.image_url = this.domSanitizer.bypassSecurityTrustStyle(banner.image_url)['changingThisBreaksApplicationSecurity'];
    });
  }

  routeToService(service_index, banner_title) {
    this.googleEvent('marketing_banner', banner_title);
    // const index: number = this.services.findIndex(service => service.id === id);
    this.router.navigate(['/services/booking'], {
      queryParams: { serviceIndex: service_index },
      relativeTo: this.route
    });
  }

  routeToExternalPage(url, banner_title) {
    this.googleEvent('marketing_banner', banner_title);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  googleEvent(section, cardTitle) {
    this.googleAnalyticsEvents.eventEmitter(cardTitle, 'home - ' + section, 'home', 10);
  }

  public onIndexChange(index: number): void {
    this.currentIndex = index;
    this.bannerCountCurrent = index + 1;

    this.googleEvent('marketing banners', 'banners swipe');
  }

  handleTouchStart(event) {
    const firstTouch = this.getTouches(event);

    if (firstTouch) {
      this.xDown = firstTouch[0].clientX;
      this.yDown = firstTouch[0].clientY;
    }
  }

  getTouches(event) {
    return event.touches;
  }

  swiperTouch(event) {
    if (event.touches) {
      const xUp = event.touches[0].clientX;
      const yUp = event.touches[0].clientY;

      const xDiff = this.xDown - xUp;
      const yDiff = this.yDown - yUp;

      const positionX = event.pageX;
      const positionY = event.pageY - event.offsetY;
      const pageElement = event.offsetParent;

      if (yDiff > 0) {
        window.scrollBy({
          top: 15,
          left: 0,
          behavior: 'smooth'
        });
      } else {
        window.scrollBy({
          top: -15,
          left: 0,
          behavior: 'smooth'
        });
      }
    }
  }
}
